import { MqttClient } from "mqtt";
import { createAction } from "@reduxjs/toolkit";
import { TagBar } from "@/store/reducers/globalReducer"
import { ThemeType } from "@/utils/theme";
import { GetSystemSetResult } from "@/request/modules/gen_api_4059";
import { PostUserLoginResult } from "@/request/modules/gen_api_4041";
import { GetVideoRealTimeSessionResult } from "@/request/modules/gen_api_4194";
import { GetUserShowResult } from "@/request/modules/gen_api_4959";

export const setCollapsed = createAction("global/setCollapsed", (payload: boolean) => ({ payload }));

export const setThemeType = createAction("global/setThemeType", (payload: ThemeType) => ({ payload }));

export const setSelectedKeys = createAction("global/setSelectedKeys", (payload?: string[]) => ({ payload }));

export const setOpenKeys = createAction("global/setOpenKeys", (payload?: string[]) => ({ payload }));

export const addTags = createAction("global/addTags", (payload: TagBar) => ({ payload }));

export const delTags = createAction("global/delTags", (payload: string) => ({ payload }));

export const clearTags = createAction("global/clearTags");

export const setSystemConfig = createAction("global/setSystemConfig", (payload: GetSystemSetResult) => ({ payload }));

export const setLoginResult = createAction("user/setLoginResult", (payload?: PostUserLoginResult | (GetUserShowResult & { token: string })) => ({ payload }));

export const setClient = createAction("mqtt/setClient", (payload?: MqttClient) => ({ payload }));

export const setConnected = createAction("mqtt/setConnected", (payload?: boolean) => ({ payload }));

export const setVideoReals = createAction("mqtt/setVideoReals", (payload?: GetVideoRealTimeSessionResult[]) => ({ payload }));